
const PersonalSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Beyond the Studio</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            When I'm not behind the camera or designing for clients, I explore personal creative projects and artistic endeavors.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Personal Interests */}
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Personal Interests</h3>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-camera-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Fine Art Photography</h4>
                  <p className="text-gray-600">
                    Personal artistic exploration through experimental techniques and conceptual projects that push creative boundaries.
                  </p>
                  <a 
                    href="/fine-art" 
                    className="inline-flex items-center text-teal-600 hover:text-teal-700 font-medium mt-2 transition-colors duration-300"
                  >
                    View Fine Art Gallery
                    <i className="ri-arrow-right-line ml-1"></i>
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-palette-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Performing Arts</h4>
                  <p className="text-gray-600">
                    Live theater and performing arts including performing Balet Folklorico with my family for fun.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-book-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Continuous Learning</h4>
                  <p className="text-gray-600">
                    Staying current with emerging technologies, design trends, and photographic techniques through workshops and experimentation.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="aspect-square rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/3fdc746f0d1d84f2cde4df046cd392e8/a564ef24d7f46df473f2efbec0483bfc.jpeg"
                alt="Personal creative work"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-teal-600 rounded-2xl flex items-center justify-center">
              <i className="ri-lightbulb-line text-4xl text-white"></i>
            </div>
          </div>
        </div>

        {/* Philosophy */}
        <div className="mt-20 text-center">
          <div className="bg-gradient-to-r from-teal-50 to-blue-50 rounded-2xl p-8 md:p-12">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Creative Philosophy</h3>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              "I believe that great design and photography come from understanding not just the technical aspects, 
              but the emotional and cultural context of what we're creating. Every project is an opportunity to 
              tell a story, solve a problem, and create something meaningful that resonates with people."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PersonalSection;
